import { render, staticRenderFns } from "./ProjetoImportaXML.vue?vue&type=template&id=30712621&"
import script from "./ProjetoImportaXML.vue?vue&type=script&lang=js&"
export * from "./ProjetoImportaXML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports